import Errors from "../classes/Errors";
import Vue from 'vue';
import Dropzone from 'dropzone';
import { forEach } from "lodash";

Vue.component('pitch-participation-component', {
    props: [
        'fileUploadUrl',
        'formSubmitUrl',
        'ndaAcceptUrl',
        'successUrl',
        'showNda',
    ],

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            teamSearch: false,
            dropZone: null,
            canSubmit: false,
            errors: new Errors(),
            fileError: null,
            filesAdded: false,
            countFiles: null,
            totalFilesize: 0,
            filesizeRemaining: 500,
            show: 'nda',
        };
    },

    watch: {
        show: function (value) {
            if(value == 'form') {
                Vue.nextTick(() => {
                    this.initDropZone();
                });
            }
        },
    },

    /**
     * Initialize drop zone when component has mounted.
     */
    mounted() {
        // Dropzone.autoDiscover = false;

        // Don't show NDA if already accepted.
        if (!this.showNda) {
            this.setShow('instructions');
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setShow(value) {
            this.show = value;

            Vue.nextTick(() => {
                this.$root.splitLines();
                this.$root.initRevealTriggers();
            });
        },

        /**
         * Accepts NDA for this pitch for this user.
         */
        acceptNda() {

            // Trigger storing agreement in DB.
            axios
                .get(this.ndaAcceptUrl)
                .then(response => {
                    if (!response.data.success) {
                        console.log(response.data.data.errors);
                    }
                })
                .catch(error => {
                    console.log(error);
                });

            // Move to instructions screen.
            this.setShow('instructions');
        },

        /**
         * Initialize drop zone to handle file uploads.
         */
        initDropZone() {

            // Set craft csrf token to add to form params.
            let formParams = {};
            formParams[window.csrfTokenName] = window.csrfTokenValue;

            // Create dropzone instance with desired settings.
            this.dropZone = new Dropzone('#pitch-upload', {
                url: this.fileUploadUrl,
                maxFiles: 99,
                maxFilesize: 500,
                params: formParams,
                previewsContainer: '.dropzone-previews',
                clickable: ".add-files-icon-holder",
                previewTemplate: document.querySelector('#tpl').innerHTML,
            });
    
            // Don't allow form submit when a new file has been added.
            this.dropZone.on('addedfile', () => {
                this.canSubmit = false;
                this.fileError = null;
                this.filesAdded = true;

                this.checkFiles();
            });
            this.dropZone.on('removedfile', () => {
                this.checkFiles();
            });
    
            // Allow form submit again when the whole queue has completed processing.
            this.dropZone.on('queuecomplete', () => {
                this.canSubmit = true;
                this.fileError = null;
            });

            this.dropZone.on("error", (file, message, xhr) => {
                this.fileError = message;
                // this.dropzone.removeFile(file); 
            });
        },

        checkFiles() {
            this.countFiles = this.dropZone.files.length;

            this.totalFilesize = 0;
            var totalBytes = 0;
            this.dropZone.files.forEach(element => {
                totalBytes += element.size;
            });
            this.totalFilesize = (totalBytes * 0.0009765625).toFixed(2);
            this.filesizeRemaining = (500 - (totalBytes / 1000000)).toFixed(2);
        },

        /**
         * Toggle the team search.
         */
        toggleTeamSearch() {
            this.teamSearch = !this.teamSearch;
        },

        /**
         * Submit the form.
         * 
         * @param Event evt
         */
        formSubmit(evt) {

            // Check if submitting is allowed and disallow after.
            if (!this.canSubmit) {
                return;
            }
            this.canSubmit = false;

            // Clear any current errors.
            this.errors.clear();

            // Post form data.
            const form = evt.currentTarget;
            axios
            .post(this.formSubmitUrl, new FormData(form))
            .then(response => {

                // Check post result.
                const result = response.data;

                // Handle error result, allow submitting again and return.
                if (!result.success && result.data) {
                    this.errors.record(result.data.errors);
                    this.canSubmit = true;
                    return;
                }

                // Redirect to thank you page.
                window.location = this.successUrl;
            })
            .catch(error => {
                this.canSubmit = true;
                console.log(error);
            });
        },
    },
});
